var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable modal-xs",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×\n                ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter,
                        expression: "filter"
                      }
                    ],
                    staticClass: "form-control mb-3",
                    attrs: { placeholder: _vm.$t("txtSearch") },
                    domProps: { value: _vm.filter },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.filter = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c("div", [
                    _c("b", [_vm._v(" " + _vm._s(_vm.$t("txtSelected")) + " ")])
                  ]),
                  _vm._v(" "),
                  _vm.selectedFiltered && _vm.selectedFiltered.length
                    ? _c(
                        "ul",
                        { staticClass: "list-group w-100" },
                        _vm._l(_vm.selectedFiltered, function(sel) {
                          return _c(
                            "li",
                            {
                              key: sel.id,
                              staticClass: "list-group-item c-pointer p-1 px-2",
                              on: {
                                click: function($event) {
                                  return _vm.remove(sel)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.labelFunc(sel)) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.selected.length
                    ? _c("div", [
                        _vm._v(
                          " " +
                            _vm._s("(" + _vm.$t("generalNothingToShow") + ")")
                        )
                      ])
                    : _c("div", [
                        _vm._v(" " + _vm._s("(" + _vm.emptyText + ")"))
                      ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c("div", [
                    _c("b", [
                      _vm._v(" " + _vm._s(_vm.$t("txtAvailable")) + " ")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.availableFiltered.length
                    ? _c(
                        "ul",
                        { staticClass: "list-group w-100" },
                        _vm._l(_vm.availableFiltered, function(avail) {
                          return _c(
                            "li",
                            {
                              key: avail.id,
                              staticClass: "list-group-item c-pointer p-1 px-2",
                              on: {
                                click: function($event) {
                                  return _vm.add(avail)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.labelFunc(avail)) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.available.length
                    ? _c("div", [
                        _vm._v(
                          " " +
                            _vm._s("(" + _vm.$t("generalNothingToShow") + ")")
                        )
                      ])
                    : _c("div", [
                        _vm._v(" " + _vm._s("(" + _vm.emptyText + ")"))
                      ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.showFooterButtons
              ? _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm._t("footerButtons"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        on: { click: _vm.dismiss }
                      },
                      [_vm._v(_vm._s(_vm.$t("btnClose")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.selectedButtonAction }
                      },
                      [_vm._v(_vm._s(_vm.$t("general.select")))]
                    )
                  ],
                  2
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }